import { PrimarySubmitButton } from 'ia-react-core';
import styled from 'styled-components';

export const StyledSubmitButton = styled(PrimarySubmitButton)`
  line-height: normal;
  white-space: normal;
`;
